// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const kyurem_black: PokeData = {
  "id": 10022,
  "name": "kyurem-black",
  "height": 33,
  "weight": 3250,
  "base_experience": 350,
  "types": [
    PokeType.DRAGON,
    PokeType.ICE
  ],
  "api_moves": [
    "ice-beam",
    "blizzard",
    "dragon-rage",
    "slash",
    "icy-wind",
    "outrage",
    "dragon-breath",
    "ancient-power",
    "endeavor",
    "imprison",
    "hyper-voice",
    "sheer-cold",
    "dragon-pulse",
    "freeze-shock",
    "fusion-bolt",
    "noble-roar",
    "freeze-dry"
  ],
  "moves": [
    "blizzard",
    "outrage",
    "dragon-breath",
    "ancient-power",
    "hyper-voice",
    "sheer-cold",
    "dragon-pulse",
    "ice-punch",
    "great-roar",
    "dragon-dance",
    "scale-shot",
    "chilly-reception",
    "dragon-rush"
  ],
  "evolution_chain": {
    "id": 333,
    "item": null,
    "species": [
      {
        "name": "kyurem",
        "order": 647,
        "types": [
          PokeType.DRAGON,
          PokeType.ICE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 117,
    "speed": 101,
    "ability_power": 181
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
